export default __webpack_public_path__ + "media/src/assets/images/info_icon-10a1f05aceb046b266dca8d68f3221d5.svg";